const STORAGE_BASES = [
  process.env.REACT_APP_STORAGE_URL,
  "https://storage.googleapis.com/greentill-dev-eu/",
  "https://storage.googleapis.com/greentill-prod-eu/",
  "https://greentill-cms.openxcell.dev/"
].filter(Boolean);

/**
 * Ensures media URLs work from nested CMS routes (e.g. /store/slider).
 * Relative paths without a protocol resolve against storage, not the current route.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== "string") {
    return "";
  }

  const trimmed = url.trim();
  if (!trimmed) {
    return "";
  }

  if (/^(https?:|data:|blob:)/i.test(trimmed)) {
    return trimmed;
  }

  if (trimmed.startsWith("//")) {
    return `https:${trimmed}`;
  }

  const path = trimmed.replace(/^\//, "");
  const storageBase = STORAGE_BASES[0];
  if (storageBase) {
    return `${storageBase.replace(/\/$/, "")}/${path}`;
  }

  if (trimmed.startsWith("/")) {
    return `${window.location.origin}${trimmed}`;
  }

  return `${window.location.origin}/${path}`;
}

export default resolveMediaUrl;
